import { render, staticRenderFns } from "./RepairProject.vue?vue&type=template&id=081b16f9&scoped=true"
import script from "./RepairProject.vue?vue&type=script&lang=js"
export * from "./RepairProject.vue?vue&type=script&lang=js"
import style0 from "./RepairProject.vue?vue&type=style&index=0&id=081b16f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b16f9",
  null
  
)

export default component.exports